// extracted by mini-css-extract-plugin
export default {"data-hook-wrapper":"_2d-Au","dataHookWrapper":"_2d-Au","core-badge":"_1YH2L","coreBadge":"_1YH2L"};